import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Box, CnAsyncSelect, Select, formilyReact, CnIcon, CnButton, CnDialog } from '@alife/cn-ui';
import { isEmpty } from 'lodash-es';
import { FIELD_STATE_OPTIONS, ALL_FIELDS_KEY } from "../const";
import { FieldsOptionContext } from "../view";
import { isFormHooks } from "../utils";
import DataSetter from "./data-setter";
var Field = formilyReact.Field,
  ArrayField = formilyReact.ArrayField,
  useField = formilyReact.useField,
  useForm = formilyReact.useForm,
  observer = formilyReact.observer;
export function getFieldsLabelList(fields) {
  if (fields === void 0) {
    fields = [];
  }
  return fields.map(function (item) {
    return {
      label: item.label + "(" + item.name + ")",
      value: item.name
    };
  });
}
var ArrayComponent = observer(function () {
  var _field$value;
  var field = useField();
  var form = useForm();
  var fieldsOption = React.useContext(FieldsOptionContext);
  var dataRef = React.useRef(null);
  return /*#__PURE__*/React.createElement("div", null, (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.map(function (item, index) {
    var _field$value2;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      style: {
        marginBottom: index === ((_field$value2 = field.value) === null || _field$value2 === void 0 ? void 0 : _field$value2.length) - 1 ? 0 : 10
      }
    }, /*#__PURE__*/React.createElement(Box, {
      direction: 'row',
      align: 'flex-start'
    }, /*#__PURE__*/React.createElement(Box, {
      direction: 'row',
      align: 'flex-start',
      style: {
        marginRight: 16,
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(Field, {
      name: index + ".field",
      component: [Select, {
        showSearch: true,
        mode: 'tag',
        placeholder: '选择字段',
        style: {
          flex: 1
        },
        dataSource: [{
          value: ALL_FIELDS_KEY,
          label: '全部字段'
        }].concat(fieldsOption)
      }]
    }), /*#__PURE__*/React.createElement(Field, {
      name: index + ".state",
      reactions: function reactions(stateField) {
        var _field$getState$value, _field$getState$value2, _form$query;
        var dataValue = (_field$getState$value = field.getState().value) === null || _field$getState$value === void 0 ? void 0 : (_field$getState$value2 = _field$getState$value[index]) === null || _field$getState$value2 === void 0 ? void 0 : _field$getState$value2.data;

        // TODO：校验老Schema是否兼容
        // 1. 先判断是否存在conditions，存在则是多条件Schema，不存在则是单条件Schema；
        // 2. 判断conditions长度，如果长度为1，则说明是单条件；使用isFormHook
        // 3. 否则是多条件，多条件则isFoomHook为true

        var isFormHook;
        var conditionsField = (_form$query = form.query("reactions." + field.indexes[0] + ".conditions")) === null || _form$query === void 0 ? void 0 : _form$query.take();
        if (!isEmpty(conditionsField)) {
          var _conditionsField$getS, _conditionsField$getS2;
          // 新的多条件Schema
          var isMulConditions = ((_conditionsField$getS = conditionsField.getState()) === null || _conditionsField$getS === void 0 ? void 0 : (_conditionsField$getS2 = _conditionsField$getS.value) === null || _conditionsField$getS2 === void 0 ? void 0 : _conditionsField$getS2.length) > 1;
          if (isMulConditions) {
            // 配置了多条条件
            isFormHook = true;
          } else {
            var _conditionsField$getS3, _conditionsField$getS4;
            // 只有一条条件
            var effectsValue = (_conditionsField$getS3 = conditionsField.getState()) === null || _conditionsField$getS3 === void 0 ? void 0 : (_conditionsField$getS4 = _conditionsField$getS3.value) === null || _conditionsField$getS4 === void 0 ? void 0 : _conditionsField$getS4[0].effects;
            isFormHook = isFormHooks(effectsValue);
          }
        } else {
          var _form$query$take;
          // 旧的单条件Schema
          var _effectsValue = (_form$query$take = form.query("reactions." + field.indexes[0] + ".effects").take()) === null || _form$query$take === void 0 ? void 0 : _form$query$take.value;
          isFormHook = isFormHooks(_effectsValue);
        }
        stateField.setComponentProps({
          innerAfter: ['initialValue', 'value', 'dataSource'].includes(stateField.value) ? /*#__PURE__*/React.createElement(CnButton, {
            text: true,
            type: 'primary',
            style: dataValue ? {
              color: '#f77103'
            } : {},
            onClick: function onClick(event) {
              var dialog = CnDialog.show({
                style: {
                  width: '800px'
                },
                title: "\u8D4B\u503C\u914D\u7F6E\uFF08" + (stateField.value === 'value' ? '值' : '枚举') + "\uFF09",
                content: /*#__PURE__*/React.createElement(DataSetter, {
                  ref: dataRef,
                  defaultValue: dataValue,
                  isFormHook: isFormHook
                }),
                onOk: function onOk() {
                  var finalFieldValue = field.value.map(function (v, i) {
                    if (i === index) {
                      return _extends({}, v, {
                        data: dataRef.current.getData()
                      });
                    }
                    return v;
                  });
                  field.setState({
                    value: finalFieldValue
                  });
                  dialog.hide();
                }
              });
              event.stopPropagation();
            }
          }, "\u53BB", dataValue ? '编辑' : '设置') : null
        });
      },
      component: [CnAsyncSelect, {
        placeholder: '条件生效时状态',
        style: {
          width: 130
        },
        dataSource: FIELD_STATE_OPTIONS,
        autoWidth: false
      }]
    })), /*#__PURE__*/React.createElement(Box, {
      direction: 'row',
      align: 'center',
      spacing: 4,
      style: {
        width: 45
      }
    }, /*#__PURE__*/React.createElement(CnIcon, {
      style: {
        cursor: 'pointer',
        color: '#284cc0',
        height: '32px'
      },
      type: "add-r",
      size: 'large',
      onClick: function onClick() {
        field.insert(index + 1, {});
      }
    }), field.value.length > 1 && /*#__PURE__*/React.createElement(CnIcon, {
      type: "minus-r",
      size: 'large',
      style: {
        cursor: 'pointer',
        color: '#e55346',
        height: '32px'
      },
      onClick: function onClick() {
        field.remove(index);
      }
    }))));
  }));
});
export default (function (_ref) {
  var name = _ref.name;
  if (!Box || !Select) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ArrayField, {
    name: name,
    component: [ArrayComponent]
  });
});